import React from "react";
import PatternOptionPctDegCount from "../PatternOptionPctDegCount";

export default props => <PatternOptionPctDegCount {...props} type="deg" />;
